import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
class HttpInvalidTokenInterceptor implements HttpInterceptor {
  public static loginPath = '';
  translate = inject(TranslateService);
  router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const login = [
      '/',
      {
        outlets: {
          primary: HttpInvalidTokenInterceptor.loginPath,
          popup: null,
          'popup-full': null,
          sidebar: null,
        },
      }
    ];

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.error['error'] === 'invalid_token') {
          const statusMessages = [];
          statusMessages.push({
            severity: 'warn',
            summary: this.translate.instant('auth.errors.invalid_token'),
          });
          this.router.navigate(login, { queryParams: { statusMessages: JSON.stringify(statusMessages) } });
        }
        return throwError(() => err);
      })
    );
  }
}

export const httpInvalidTokenInterceptorFn = function(loginPath: string) {
  HttpInvalidTokenInterceptor.loginPath = loginPath
  return HttpInvalidTokenInterceptor
}
